import { useEffect, useMemo } from 'react';
import { useSettings } from '../../core/contexts/SettingsContext';
import localApiAdapter from '../../core/services/localApiAdapter';
import { DEFAULT_INVENTORY_CONFIG, normalizeInventoryConfig, buildInventoryEntityPrefixes } from './inventaireConfigDefaults';

let hydratePromise = null;

function hydrateInventoryConfig(patchSettings) {
  if (!hydratePromise) {
    hydratePromise = localApiAdapter
      .get('/inventory/config')
      .then((response) => {
        const raw = response?.data !== undefined ? response.data : response;
        const normalized = normalizeInventoryConfig(raw || {});
        syncInventoryConfigToSettings(normalized, patchSettings);
        return normalized;
      })
      .catch(() => {
        hydratePromise = null;
        return DEFAULT_INVENTORY_CONFIG;
      });
  }
  return hydratePromise;
}

/** Live inventory module config — synced from API once, then from SettingsContext. */
export function useInventoryConfig() {
  const { settings, patchSettings } = useSettings();

  useEffect(() => {
    if (settings?.inventory && Object.keys(settings.inventory).length > 0) return;
    void hydrateInventoryConfig(patchSettings);
  }, [settings?.inventory, patchSettings]);

  return useMemo(
    () => normalizeInventoryConfig(settings?.inventory || {}),
    [settings?.inventory],
  );
}

export function syncInventoryConfigToSettings(config, patchSettings, existingSettings = {}) {
  const normalized = normalizeInventoryConfig(config);
  patchSettings({
    inventory: normalized,
    configuration: {
      entityPrefixes: {
        ...(existingSettings?.configuration?.entityPrefixes || {}),
        ...buildInventoryEntityPrefixes(normalized),
      },
    },
  }, { persist: false });
  return normalized;
}
